import api from "../axiosInstance";

// Get all email templates
export const getAllEmailTemplatesAPI = async () => {
  try {
    const response = await api.get(
      process.env.REACT_APP_API_URL + "/api/v1/email-template"
    );
    return response.data;
  } catch (e) {
    console.log("Error getting email templates: " + e.message);
    throw e;
  }
};

// Get email template by type
export const getEmailTemplateByTypeAPI = async (templateType) => {
  try {
    const response = await api.get(
      process.env.REACT_APP_API_URL + `/api/v1/email-template/${templateType}`
    );
    return response.data;
  } catch (e) {
    console.log("Error getting email template: " + e.message);
    throw e;
  }
};

// Create email template
export const createEmailTemplateAPI = async (payload) => {
  try {
    const response = await api.post(
      process.env.REACT_APP_API_URL + "/api/v1/email-template",
      payload
    );
    return response.data;
  } catch (e) {
    console.log("Error creating email template: " + e.message);
    throw e;
  }
};

// Update email template
export const updateEmailTemplateAPI = async (id, payload) => {
  try {
    const response = await api.put(
      process.env.REACT_APP_API_URL + `/api/v1/email-template/${id}`,
      payload
    );
    return response.data;
  } catch (e) {
    console.log("Error updating email template: " + e.message);
    throw e;
  }
};

// Delete email template
export const deleteEmailTemplateAPI = async (id) => {
  try {
    const response = await api.delete(
      process.env.REACT_APP_API_URL + `/api/v1/email-template/${id}`
    );
    return response.data;
  } catch (e) {
    console.log("Error deleting email template: " + e.message);
    throw e;
  }
};

// Toggle email template status
export const toggleTemplateStatusAPI = async (id) => {
  try {
    const response = await api.patch(
      process.env.REACT_APP_API_URL +
        `/api/v1/email-template/${id}/toggle-status`
    );
    return response.data;
  } catch (e) {
    console.log("Error toggling template status: " + e.message);
    throw e;
  }
};
